import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af7b1db6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "space-y-5 text-sm" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "info-grid" }
const _hoisted_4 = { class: "input-form-label text-gray-500" }
const _hoisted_5 = { class: "mt-1" }
const _hoisted_6 = { key: 1 }

import { computed, defineComponent, h, PropType } from "vue";

import StatusLabel from "@/components/common/StatusLabel.vue";
import { t } from "@/i18n";

interface CompanyPayload {
  id?: string | null;
  name?: string | null;
  index?: string | null;
  status?: string | null;
  position?: number | null;
  bin?: string | null;
  personType?: string | null;
  person_type?: string | null;
  isCompany?: boolean | null;
  is_company?: boolean | null;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    payload: null
  },
  setup(__props: any) {

const props = __props as {
  payload: Record<string, unknown> | CompanyPayload;
}



const data = computed(() => props.payload as CompanyPayload);

const personTypeLabel = computed(() => {
  const raw = data.value.personType || data.value.person_type || "";

  if (!raw) {
    return "—";
  }

  const labels: Record<string, string> = {
    LEGAL: t("companyDetails.personTypeLegal"),
    INDIVIDUAL: t("companyDetails.personTypeIndividual"),
  };

  return labels[raw] ?? "—";
});

const isCompanyLabel = computed(() => {
  const value = data.value.isCompany ?? data.value.is_company;
  if (value == null) {
    return "—";
  }
  return value ? t("common.yes") : t("common.no");
});

const SectionTitle = defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    return () =>
      h(
        "h2",
        {
          class: "mb-5 text-lg font-semibold text-gray-800",
        },
        props.title
      );
  },
});

const InfoItem = defineComponent({
  props: {
    label: {
      type: String,
      required: true,
    },

    value: {
      type: [String, Number] as PropType<string | number>,
      default: "—",
    },
  },

  setup(props, { slots, attrs }) {
    return () =>
      h("div", attrs, [
        h(
          "span",
          {
            class: "input-form-label text-gray-500",
          },
          props.label
        ),

        h(
          "p",
          {
            class: "mt-1 break-words text-gray-800",
          },
          slots.default ? slots.default() : String(props.value || "—")
        ),
      ]);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(SectionTitle), {
        title: _unref(t)('entityApproval.company.mainInfo')
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(InfoItem), {
          label: _unref(t)('common.title'),
          value: _unref(data).name || '—'
        }, null, 8, ["label", "value"]),
        _createVNode(_unref(InfoItem), {
          label: _unref(t)('companyDetails.index'),
          value: _unref(data).index || '—'
        }, null, 8, ["label", "value"]),
        _createVNode(_unref(InfoItem), {
          label: _unref(t)('companyDetails.bin'),
          value: _unref(data).bin || '—'
        }, null, 8, ["label", "value"]),
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)("common.status")), 1),
          _createElementVNode("div", _hoisted_5, [
            (_unref(data).status)
              ? (_openBlock(), _createBlock(StatusLabel, {
                  key: 0,
                  label: String(_unref(data).status)
                }, null, 8, ["label"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, "—"))
          ])
        ]),
        _createVNode(_unref(InfoItem), {
          label: _unref(t)('companyDetails.position'),
          value: _unref(data).position != null ? String(_unref(data).position) : '—'
        }, null, 8, ["label", "value"]),
        _createVNode(_unref(InfoItem), {
          label: _unref(t)('companyDetails.personType'),
          value: String(_unref(personTypeLabel))
        }, null, 8, ["label", "value"]),
        _createVNode(_unref(InfoItem), {
          label: _unref(t)('companyDetails.isCompany'),
          value: _unref(isCompanyLabel)
        }, null, 8, ["label", "value"])
      ])
    ])
  ]))
}
}

})